<template>
  <div class="container">
    <!-- <searchBox></searchBox> -->
    <search-box frompage="分类列表页" />

    <div class="list-box">
      <div
        v-if="!categoryList.parentCategoryNameWithCulture"
        class="list-one-box"
      >
        <img
          src="../../../assets/helpQue.png"
          alt="##"
        >
        <span>{{ categoryList.categoryNameWithCulture }}</span>
      </div>
      <!-- 二级分类页 标题 -->
      <div
        v-else
        :class="['list-one-box', 'list-ones-box']"
        @click="goSubList(categoryList.parentCategoryID)"
      >
        <img
          src="../../../assets/helpQue.png"
          alt="##"
        >
        <span>{{ categoryList.parentCategoryNameWithCulture }}</span>
      </div>

      <!-- 一级分类页存在二级分类 -->
      <template v-if="childCategorys && childCategorys.length > 0">
        <div
          v-for="(item, index) in childCategorys"
          :key="index"
          class="list-two-box"
        >
          <div
            class="list-two-tit"
            @click="goSubList(item.categoryID)"
          >
            {{ item.categoryNameWithCulture }}
          </div>
          <div
            v-for="(it, ind) in item.questionSimpleResponses"
            :key="ind"
          >
            <div
              class="list-two-con"
              @click="goMainBody(it, 'containSec')"
            >
              <p>></p>
              &nbsp;{{ it.titleNameWithCulture }}
            </div>
          </div>
          <!-- 查看更多 -->
          <div
            v-if="item.questionCount > 6 && childCategorys && childCategorys.length > 0"
            class="list-more-box"
            @click="goSubList(item.categoryID)"
          >
            查看所有{{ item.questionCount }}篇文章&nbsp;>
          </div>
        </div>
      </template>
      <!-- 仅有 一级分类页 或 二级分类页 -->
      <template v-if="categoryList.questionSimpleResponses && categoryList.questionSimpleResponses.length > 0">
        <div
          v-if="categoryList.parentCategoryID"
          :class="['list-two-tit', 'list-twos-tit']"
        >
          {{ categoryList.categoryNameWithCulture }}
        </div>
        <div
          v-for="(it, ind) in categoryList.questionSimpleResponses"
          :key="ind"
          class="list-two-boxs"
        >
          <div
            class="list-two-con"
            @click="goMainBody(it, categoryList.parentCategoryID)"
          >
            <p>></p>
            &nbsp;{{ it.titleNameWithCulture }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import SearchBox from './searchBox.vue';
export default {
    components: {
        SearchBox
    },
    data() {
        return {
            categoryList: {},
            childCategorys: [], //有二级问题列表
            questionSimpleResponses: [], //无二级问题列表
            containListType: '' //埋点_当前列表页
        };
    },
    computed: {
        categoryID() {
            return this.$store.state.selectLi;
        }
    },
    watch: {
        $route(to, from) {
            if (to.query.categoryID != from.query.categoryID) {
                // 瀏覽器返回左側樣式動態
                this.$store.commit('changeSelectLi', to.query.categoryID);
                this.GetListByCategoryId(to.query.categoryID);
            }
        }
        // categoryID: {
        //     deep: true,
        //     immediate: true,
        //     handler(value) {
        //         console.log("222",value)
        //         this.GetListByCategoryId(value);
        //     }
        // }
    },
    created() {
        if (this.$route.query.categoryID) {
            this.$store.commit('changeSelectLi', this.$route.query.categoryID);
            this.GetListByCategoryId(this.$route.query.categoryID);
        }
        // this.GetListByCategoryId(this.$store.state.selectLi);
    },
    methods: {
        // 去正文
        goMainBody(it, containType) {
            let type = '';
            if (containType == 'containSec') {
                type = '幫助中心一級分類列表（二級文章列表預覽）';
            } else if (containType) {
                type = '幫助中心二級分類列表（二級文章列表）';
            } else {
                type = '幫助中心一級分類列表頁（一級文章列表）';
            }
            this.$store.commit('changefrompage',type);

            gio('track', 'element_click', {
                channel: '幫助中心',
                location: `${type}_${it.titleNameWithCulture}`,
                element_content: it.titleNameWithCulture,
                element_link: `/helpcenter/mainbody?questionId=${it.id}`,
                element_name: it.titleNameWithCulture,
                page: `${type}`,
                platform: 'web'
            });
            gio('evar.set', {
                evar_ad_position: `${type}_${it.titleNameWithCulture}`,
                evar_page: `${type}`   
            });
            this.$store.commit('changeSelectLi', this.$route.query.categoryID);
            this.$router.push({ path: '/helpcenter/mainbody', query: { questionId: it.id } });
            // this.$router.push({ name: this.pub.routeNameLists.MainBody, params: { questionId: it.id } });
            let arr = [];
            if (JSON.parse(localStorage.getItem('questionId'))) {
                arr = JSON.parse(localStorage.getItem('questionId'));
            } else {
                arr = [];
            }
            arr = [...new Set(arr)];
            arr.unshift(it.id);
            if (arr.length > 5) {
                arr.pop();
            }
            localStorage.setItem('questionId', JSON.stringify(arr));
        },
        goSubList(item) {
            this.$store.commit('changeSelectLi', item);
            this.$router.push({ path: '/helpcenter/asidelist', query: { categoryID: item} });
        },
        GetListByCategoryId(value) {
            this.axios.get(this.pub.getApi().GetListByCategoryId, { params: { categoryId: value } }).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.categoryList = res.data.result;
                    // 有二级
                    this.childCategorys = res.data.result.childCategorys;
                    // 无二级
                    this.questionSimpleResponses = res.data.result.questionSimpleResponses;
                    this.containListType = '';
                    if (this.childCategorys && this.childCategorys.length > 0) {
                        this.containListType = '幫助中心一級分類列表（二級文章列表預覽）';
                    } else if (this.categoryList.parentCategoryID) {
                        this.containListType = '幫助中心二級分類列表（二級文章列表）';
                    } else if (!this.childCategorys.length) {
                        this.containListType = '幫助中心一級分類列表頁（一級文章列表）';
                    }
                    gio('track', 'enter_in', {
                        channel: '幫助中心',
                        page: `${this.containListType}`,
                        platform: 'web'
                    });
                }
            });
        }
    }
};
</script>

<style scoped lang="less">
.container {
    padding-left: 20px;
    padding-right: 20px;
    background-color: #f3f3f5;
    .list-box {
        text-align: left;
        width: 100%;
        margin-top: 30px;
        border-radius: 15px;
        background-color: #fff;
        padding: 0 20px 20px;
        .list-one-box {
            font-size: 24px;
            color: #444444;
            font-weight: 700;
            height: 83px;
            line-height: 83px;
            margin-bottom: 30px;
            border-bottom: 1px solid #eeeeee;
            img {
                margin-right: 8px;
                width: 23px;
                height: 20px;
                display: inline-block;
            }
        }
        .list-ones-box {
            cursor: pointer;
        }
        .list-two-tit {
            font-size: 18px;
            color: #444444;
            font-weight: 700;
            margin-bottom: 5px;
            cursor: pointer;
        }
        .list-twos-tit {
            cursor: default;
        }
        div.list-two-boxs > div {
            margin-top: 30px;
        }
        .list-two-boxs {
            .list-two-con {
                cursor: pointer;
                font-size: 16px;
                color: #666666;
                margin-top: 10px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                p {
                    color: #0062ff;
                    margin-right: 6px;
                    display: inline-block;
                    font-weight: 700;
                    font-size: 14px;
                    vertical-align: text-top;
                }
            }
            .list-two-con:hover {
                text-decoration: underline;
            }
        }
        .list-two-box {
            margin-top: 30px;
            .list-two-con {
                cursor: pointer;
                font-size: 16px;
                color: #666666;
                margin-top: 10px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                p {
                    color: #0062ff;
                    margin-right: 6px;
                    display: inline-block;
                    font-weight: 700;
                    font-size: 14px;
                    vertical-align: text-top;
                }
            }
            .list-two-con:hover {
                text-decoration: underline;
            }
            .list-more-box:hover {
                text-decoration: underline;
            }
            // .list-two-tit {
            //     font-size: 18px;
            //     color: #444444;
            //     font-weight: 700;
            //     margin-bottom: 5px;
            //     cursor: pointer;
            // }
            .list-more-box {
                cursor: pointer;
                color: #0062ff;
                font-size: 16px;
                margin-top: 10px;
                margin-left: 24px;
            }
        }
    }
}
</style>
